import Markdown from 'markdown-to-jsx'

import Icon from '../icons/Icon'

type GuideEntry = {
  readonly content: string
  readonly iconName: string
}

type GuideSectionProps = {
  readonly guide: {
    guideEntry: GuideEntry[]
  }
}

type GuideItemProps = {
  readonly guideItem: GuideEntry
  readonly keyNumber: number
  readonly items: number
}

const GuideItem: React.FC<GuideItemProps> = ({ guideItem, keyNumber, items }) => {
  return (
    <>
      {keyNumber !== 0 && <Icon icon="arrow" size="sm" color="default" className="mx-6 my-8 text-petrol-300" />}
      <div className={`${items === 3 ? 'tablet:col-span-3' : 'tablet:col-span-2'} `}>
        <div className="grid justify-items-center">
          <div className="m-2 mb-8 rounded-full bg-white">
            <Icon icon={guideItem.iconName} size="md" color="secondary" className="m-6" />
          </div>
        </div>
        {guideItem.content && <Markdown className="text-center text-base">{guideItem.content}</Markdown>}
      </div>
    </>
  )
}

const GuideSection: React.FC<GuideSectionProps> = ({ guide }) => {
  return (
    <div className={`grid grid-cols-1 justify-items-center p-6 text-center tablet:mb-20 tablet:grid-cols-11`}>
      {guide.guideEntry.map((guideItem, key) => {
        return <GuideItem guideItem={guideItem} key={`guide-${key}`} keyNumber={key} items={guide.guideEntry.length} />
      })}
    </div>
  )
}

export default GuideSection
